import React from 'react';
import { Link } from 'react-router-dom';

import { mergeClassNames } from 'utils/functions';

export const BlockLink = ({ className, ...domProps }) => {
    const classes = mergeClassNames(
        'text-decoration-none text-reset d-block',
        className
    );
    return <Link className={classes} {...domProps} />;
};

export default BlockLink;
